import React from "react";
import PageShell from "@/components/PageShell";
import PageHeader from "@/components/PageHeader";
import ChannelCard from "@/components/ChannelCard";
import { channels } from "@/data/enrichments";

const SECTIONS = [
  { family: "messaging", label: "WhatsApp · Daily wisdom by tradition" },
  { family: "social", label: "Social" },
  { family: "video", label: "Video" },
  { family: "music", label: "Music streaming" },
  { family: "writing", label: "Writing" },
];

export default function Follow() {
  return (
    <PageShell title="Follow">
      <PageHeader
        eyebrow="Stay in touch"
        title="Find DharmaWeave wherever you already are."
        lede="The same daily transmission, served on the platform that already has your attention."
      />
      <section className="max-w-8xl mx-auto px-5 md:px-10 lg:px-14 pb-24 md:pb-32 space-y-16 md:space-y-20">
        {SECTIONS.map((s) => {
          // Filter out channels without a URL — keeps the WhatsApp section
          // hidden until invite URLs are populated in enrichments.js.
          const list = channels.filter(
            (c) => c.family === s.family && c.url && c.url.length > 0
          );
          if (list.length === 0) return null;
          return (
            <div key={s.family}>
              <p className="eyebrow mb-6">{s.label}</p>
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
                {list.map((c, i) => (
                  <ChannelCard key={c.id} channel={c} index={i} />
                ))}
              </div>
            </div>
          );
        })}
      </section>
    </PageShell>
  );
}
